const GTM_ID = 'GTM-M7QKP75P'
const GTM_FALLBACK_DELAY_MS = 8000

const loadGTM = () => {
  if (typeof window === 'undefined' || window.__gtmLoaded) {
    return
  }

  window.__gtmLoaded = true
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ platform: 'gatsby' })
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)
}

const scheduleGTM = () => {
  let fallbackTimer

  const trigger = () => {
    if (fallbackTimer) {
      clearTimeout(fallbackTimer)
    }

    loadGTM()
  }

  ;['scroll', 'click', 'touchstart', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, trigger, {
      once: true,
      passive: true,
    })
  })

  fallbackTimer = setTimeout(trigger, GTM_FALLBACK_DELAY_MS)
}

exports.onClientEntry = () => {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  if (document.readyState === 'complete') {
    scheduleGTM()
  } else {
    window.addEventListener('load', scheduleGTM, { once: true })
  }
}

exports.onRouteUpdate = () => {
  if (process.env.NODE_ENV !== 'production' || !window.dataLayer) {
    return
  }

  setTimeout(() => {
    window.dataLayer.push({ event: 'gatsby-route-change' })
  }, 50)
}
